/** Restituisce un'email valida normalizzata (lowercase, trim) o null. */
export function sanitizeEmailParam(raw: string | null): string | null {
  if (!raw) return null;
  const v = raw.trim().toLowerCase();
  if (v.length > 254) return null;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? v : null;
}
